import React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import styles from '../AddProduct.module.css';

function BasicInformation({
    productName,
    handleProductNameChange,
    editorState,
    handleEditorChange,
    uploadCallback,
    offerMessage,
    setOfferMessage,
    video,
    setVideo,
    errorFields,
    setErrorFields,
    handleFieldChange,
}) {
    return (
        <div className={styles['AddProduct-card']}>
            <h2 className={styles['AddProduct-card-title']}>
                Basic information
            </h2>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Product title{' '}
                    <span className={styles['AddProduct-required']}>*</span>
                </label>
                <input
                    onChange={handleProductNameChange}
                    type="text"
                    className={`${styles.form__input_add} ${
                        errorFields.productName ? styles['error-field'] : ''
                    }`}
                    placeholder="Enter product title"
                    value={productName}
                />
                {errorFields.productName && (
                    <div className={styles['error-text']}>
                        Product title is required
                    </div>
                )}
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Description{' '}
                    <span className={styles['AddProduct-required']}>*</span>
                </label>
                <div
                    className={`${styles['AddProduct-editor-wrapper']} ${
                        errorFields.HtmlDesc ? styles['error-field'] : ''
                    }`}
                >
                    <Editor
                        editorState={editorState}
                        onEditorStateChange={handleEditorChange}
                        wrapperClassName={styles['AddProduct-editor-wrapper']}
                        editorClassName={styles['AddProduct-editor']}
                        toolbar={{
                            options: [
                                'inline',
                                'blockType',
                                'fontSize',
                                'list',
                                'textAlign',
                                'link',
                                'image',
                                'history',
                            ],
                            inline: {
                                inDropdown: false,
                                options: [
                                    'bold',
                                    'italic',
                                    'underline',
                                    'strikethrough',
                                    'monospace',
                                ],
                            },
                            blockType: {
                                inDropdown: true,
                                options: [
                                    'Normal',
                                    'H1',
                                    'H2',
                                    'H3',
                                    'H4',
                                    'H5',
                                    'H6',
                                    'Blockquote',
                                    'Code',
                                ],
                            },
                            fontSize: {
                                options: [
                                    8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36,
                                    48, 60, 72, 96,
                                ],
                            },
                            list: { inDropdown: true },
                            textAlign: { inDropdown: true },
                            link: {
                                inDropdown: true,
                                showOpenOptionOnHover: true,
                                defaultTargetOption: '_blank',
                            },
                            image: {
                                uploadCallback: uploadCallback,
                                alt: { present: true, mandatory: true },
                                previewImage: true,
                                inputAccept:
                                    'image/gif,image/jpeg,image/jpg,image/png,image/svg,image/webp',
                                urlEnabled: true,
                                alignmentEnabled: true,
                                uploadEnabled: true,
                            },
                            history: {
                                inDropdown: false,
                                options: ['undo', 'redo'],
                            },
                        }}
                    />
                </div>
                {errorFields.HtmlDesc && (
                    <div className={styles['error-text']}>
                        Description is required
                    </div>
                )}
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Offer message
                    <span className={styles['AddProduct-label-optional']}>
                        {' '}
                        (Optional)
                    </span>
                </label>
                <input
                    onChange={handleFieldChange(
                        'offerMessage',
                        setOfferMessage,
                        errorFields,
                        setErrorFields
                    )}
                    type="text"
                    className={styles.form__input_add}
                    placeholder="e.g., Free shipping on orders over ৳1000"
                    value={offerMessage}
                />
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Video URL
                    <span className={styles['AddProduct-label-optional']}>
                        {' '}
                        (Optional)
                    </span>
                </label>
                <input
                    onChange={handleFieldChange(
                        'video',
                        setVideo,
                        errorFields,
                        setErrorFields
                    )}
                    type="text"
                    className={styles.form__input_add}
                    placeholder="Enter YouTube or video URL"
                    value={video}
                />
            </div>
        </div>
    );
}

export default BasicInformation;
